import axios from "axios";
import { getCookie } from "./getCookie";
import Cookies from "js-cookie";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Store logout function reference
let logoutFunction = null;

// Function to set logout callback
export const setLogoutCallback = (logout) => {
  logoutFunction = logout;
};

API.interceptors.request.use(
  (config) => {
    const token = getCookie("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("error.response: ", error.response);
    if (error.response && error.response.status === 401) {
      // Clear the token from cookies
      Cookies.remove("token");
      
      // Trigger logout if callback is available
      if (logoutFunction) {
        logoutFunction();
      } else {
        // Fallback: redirect to login page
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default API;